import Market from '@/creditflowresearch/domain/Market';

export const getRegionsFromMarkets = (markets: string | string[]) => {
  const marketIds = Market.getIds(markets);
  const regions = Market.getRegionsByMarkets(marketIds);
  return regions.map((region) => region.getAbbreviation());
};
